import axios from 'axios';
import serviceConfig from '@/service/config';
import { takeTokenHandle, trimHandle, ignoreViolationParamsHandle } from '@/service/interceptors/request';
import { httpStatusExceptionHandle, responseHandle } from '@/service/interceptors/response';

// 创建axios新实例
const axiosInst = axios.create(serviceConfig);
axiosInst.interceptors.request.use(
  config => {
    takeTokenHandle(config);
    trimHandle(config);
    ignoreViolationParamsHandle(config);
    return config;
  },
  err => Promise.reject(err)
);

// 注入响应拦截器
axiosInst.interceptors.response.use(
  resp => responseHandle(resp),
  err => httpStatusExceptionHandle(err)
);

export default ({
  install: Vue =>
    Vue.prototype.$http = function (method, url, data) {
      if (method === 'get') {
        return axiosInst
          .get(url, { params: data })
          .catch(err => this.$message.error(err));
      } else {
        return axiosInst
          .post(url, data)
          .catch(err => this.$message.error(err));
      }
    }
});
